module.exports = __webpack_public_path__ + "img/1cd4e55.png";